import { FC, useMemo } from 'react'
import styles from 'components/features/future/FutureRepeatInput/FutureRepeatInput.styl'
import { RadioButton } from 'components/atoms/inputs/RadioButton/RadioButton'
import { Recurrence, WithRecurrence } from 'components/features/future/types'
import { UseFormRegister } from 'react-hook-form'

type RecurrenceWithExtra =
  | Recurrence
  | 'monthly_as_every_six_months'
  | 'every_six_months_as_monthly'

const DEFAULT_OPTIONS: RecurrenceWithExtra[] = ['one_time', 'monthly', 'yearly']
export const OPTIONS_WITH_6_MONTH: RecurrenceWithExtra[] = ['one_time', 'every_six_months', 'yearly']
export const OPTIONS_WITH_5_AND_10_YEARS: RecurrenceWithExtra[] = ['one_time', 'every_5_years', 'every_10_years']
export const LARGE_PURCHASE_OPTIONS: RecurrenceWithExtra[] = ['one_time', 'monthly_as_every_six_months', 'yearly']
export const NEW_EXPENSES_OPTIONS: RecurrenceWithExtra[] = ['one_time', 'every_six_months_as_monthly', 'yearly']

export type FutureRepeatInputProps = {
  register: UseFormRegister<WithRecurrence>
  name: string
  options?: RecurrenceWithExtra[]
}

export const FutureRepeatInput: FC<FutureRepeatInputProps> = (props) => {
  const {
    options = DEFAULT_OPTIONS,
    ...restProps
  } = props

  const optionsSet = useMemo(() => new Set(options), [options])

  return (
    <div className={ styles.futureRepeatInput }>
      { optionsSet.has('one_time') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='One Time' value='one_time' />
        </div>
      )}
      { optionsSet.has('monthly') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Monthly' value='monthly' />
        </div>
      )}
      { optionsSet.has('monthly_as_every_six_months') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Every 6 mo' value='monthly' />
        </div>
      )}
      { optionsSet.has('every_six_months') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Every 6 mo' value='every_six_months' />
        </div>
      )}
      { optionsSet.has('every_six_months_as_monthly') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Monthly' value='every_six_months' />
        </div>
      )}
      { optionsSet.has('yearly') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Annually' value='yearly' />
        </div>
      )}
      { optionsSet.has('every_5_years') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Every 5 years' value='every_5_years' />
        </div>
      )}
      { optionsSet.has('every_10_years') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Every 10 years' value='every_10_years' />
        </div>
      )}
    </div>
  )
}
